__turbopack_context__.v({
  "buttonCall": "ButtonCall-module-scss-module__mMh4dW__buttonCall",
});
